import { TranslateService } from '@ngx-translate/core';
import { ELanguageCode } from './enums/country.enum';

export function getLanguageAwareExternalUrl(
  externalUrl: string,
  translateService: TranslateService
): string {
  const currentLang = translateService.defaultLang as ELanguageCode;

  if (currentLang === ELanguageCode.EN) {
    return addEnPrefix(externalUrl);
  }

  return externalUrl;
}

function addEnPrefix(externalUrl: string): string {
  try {
    const url = new URL(externalUrl);
    const pathParts = url.pathname.split('/').filter(Boolean);

    if (pathParts.length === 0 || pathParts[0] !== 'en') {
      pathParts.unshift('en');
    }

    url.pathname = '/' + pathParts.join('/');
    return url.toString();
  } catch {
    if (externalUrl.includes('sharelock.pro/')) {
      if (!externalUrl.includes('sharelock.pro/en/')) {
        return externalUrl.replace('sharelock.pro/', 'sharelock.pro/en/');
      }
    }
    return externalUrl;
  }
}
